require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./aide-sant-et-scurit-1-9.json") })
        }
      }, "path---aide-sant-et-scurit-1-9");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---aide-sant-et-scurit-1-9!./.cache/json/aide-sant-et-scurit-1-9.json
// module id = 323
// module chunks = 231608221292675